import React, { Fragment, FunctionComponent } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import CalculatedPaymentInline from "Shared/CalculatedPaymentInline";

interface CreditApproved {
    bankName: string;
}

const CreditApproved: FunctionComponent<CreditApproved & WithTranslation> = ({ bankName, t }) => {
    return (
        <Fragment>
            <p className="StepOne__title">{t("ContinueDeal.StepOne.CreditApproved.title")}</p>
            <p className="StepOne__text">
                {t("ContinueDeal.StepOne.CreditApproved.description1")}
                <CalculatedPaymentInline />
                {t("ContinueDeal.StepOne.CreditApproved.description2", { bankName })}
            </p>
        </Fragment>
    );
};

export default withTranslation()(CreditApproved);
